// ─── Alert Service — API client for the intelligence layer alerts ────────────
// apiFetch already handles error checking and JSON parsing, so we just return
// the result directly. Errors propagate as thrown exceptions.
import { apiFetch } from './apiClient';

export async function fetchAlerts(unitId = 'all', getToken) {
  const query = unitId && unitId !== 'all' ? `?unitId=${encodeURIComponent(unitId)}` : '';
  return apiFetch(`/api/alerts${query}`, {}, getToken);
}

export async function fetchAlertById(id, getToken) {
  return apiFetch(`/api/alerts/${id}`, {}, getToken);
}

export async function fetchAlertImpacts(unitId = 'all', entities, getToken) {
  const params = new URLSearchParams();
  params.set('entities', entities.join(','));
  if (unitId && unitId !== 'all') params.set('unitId', unitId);
  return apiFetch(`/api/alerts/impacts?${params}`, {}, getToken);
}

export async function acknowledgeAlert(id, getToken) {
  return apiFetch(`/api/alerts/${id}/acknowledge`, { method: 'POST' }, getToken);
}

export async function resolveAlert(id, getToken) {
  return apiFetch(`/api/alerts/${id}/resolve`, { method: 'POST' }, getToken);
}

export async function dismissAlert(id, getToken) {
  return apiFetch(`/api/alerts/${id}/dismiss`, { method: 'POST' }, getToken);
}

export async function createAgentSession(alertId, getToken) {
  return apiFetch('/api/chatbot/agent/sessions', {
    method: 'POST',
    body: JSON.stringify({ alertId }),
  }, getToken);
}

export async function createAgentSessionFromAlert(alertId, getToken) {
  return apiFetch(`/api/chatbot/agent/from-alert/${alertId}`, {
    method: 'POST',
  }, getToken);
}
